ixModuleRouting("impactx.cxml", {
    "/cxmlrequest": {
        template:"<ixa-cxml-request></ixa-cxml-request>",
        templateUrl: "modules/cxml/templates/cxmlrequest.html",
        process: "CXMLRequest",
        controller: "CXMLRequestCtrl",
        controllerAs: "cxmlRequestCtrl",
        workspace: "system",
    },
});
